import React, { useEffect, useRef, useState } from 'react';

import * as S from './AnimatedMentalState.styles';

export const AnimatedMentalSate = () => {
  const mentalStatesRef = useRef(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  const mentalStates = [
    { text: 'focus', color: 'rgba(254, 90, 131, 1' },
    { text: 'sleep', color: 'rgba(189, 99, 244, 1)' },
    { text: 'relax', color: 'rgba(105, 202, 255, 1)' },
    { text: 'meditate', color: 'rgba(18, 218, 178, 1)' },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % mentalStates.length);
    }, 2000);

    return () => clearInterval(interval);
  }, [mentalStates.length]);

  useEffect(() => {
    if (mentalStatesRef.current) {
      const currentMentalState = mentalStatesRef.current.querySelector('span.current');
      const nextMentalState = mentalStatesRef.current.querySelector('span.next');
      const nextNextMentalState = nextMentalState.nextElementSibling
        ? nextMentalState.nextElementSibling
        : mentalStatesRef.current.firstElementChild;

      if (currentMentalState) {
        currentMentalState.classList.remove('current');
        nextMentalState.classList.remove('next');
        
        nextMentalState.classList.add('current');
        nextNextMentalState.classList.add('next');

        mentalStatesRef.current.style.setProperty('--color', nextMentalState.dataset.color);
        mentalStatesRef.current.style.setProperty('--width', `${nextMentalState.offsetWidth}px`);
      }
    }
  }, [currentIndex]);

  return (
    <S.WordsWrapper>
      <>Everything you </>
      <S.NewLine>
        <br/>
      </S.NewLine>
      <>need to</>
      <S.NewLine>
        <br/>
      </S.NewLine>
      <S.WordsContainer ref={mentalStatesRef}>
        {mentalStates.map((mentalState, index) => (
          <span
            key={index}
            className={index === currentIndex ? 'current' : index === (currentIndex + 1) % mentalStates.length ? 'next' : ''}
            data-color={mentalState.color}
          >
            {mentalState.text}
          </span>
        ))}
      </S.WordsContainer>
      <S.NewLine>
        <br/>
      </S.NewLine>
      <>better.</>
    </S.WordsWrapper>
  );
};
